import React from 'react';
import {connect} from "react-redux";
import {
  CABINET_BATHROOM_LABELS,
  SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS,
} from "../../../../../constants";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../../actions/sqftMenuFunctions";
import cabinetWorkspace from "../../../../canvas/core/cabinet/cabinetWorkspace";
import SqftOptionsRelatedItemList from "./commonParts/SqftOptionsRelatedItemList";
//import SqftWizardNavItemsList from "./commonParts/SqftWizardNavItemsList";
import SQFTFeaturesHeader from "./commonParts/SQFTFeaturesHeader";
import {FormattedMessage} from "react-intl";

const SqftNavigationVanity = (props) => {
  const {activeFeature} = props;
  const {menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS.vanity

  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")}>
      <div className="side-level2__inner ">
        <SQFTFeaturesHeader headerTitle={ <FormattedMessage id={"sqft.navigation.submenu.vanity"}/> }
                            partId={CABINET_BATHROOM_LABELS.vanity_cabinet}/>
        {expanded ?
          <>
            <SqftOptionsRelatedItemList activeFeature={activeFeature}
                                       partId={CABINET_BATHROOM_LABELS.vanity_cabinet}
                                       shouldSortByWidth={true}
                                       itemClickCallback={(feature, parentFeature) => {
                                         cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature)}
                                       }
            />
            {/*<SqftWizardNavItemsList activeFeature={activeFeature}*/}
            {/*                        partIds={[*/}
            {/*                          CABINET_BATHROOM_LABELS.vanity_cabinet_boxes,*/}
            {/*                          CABINET_BATHROOM_LABELS.vanitie_cabinet_boxes,*/}
            {/*                        ]}*/}
            {/*                        parentPartId={CABINET_BATHROOM_LABELS.vanity_cabinet}*/}
            {/*                        expanded={expanded}*/}
            {/*                        shouldSortByWidth={true}*/}
            {/*                        itemClickCallback={(feature, parentFeature) => {*/}
            {/*                          cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature)}*/}
            {/*                        }*/}
            {/*/>*/}
          </>
        : null}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {sqftFromFeature} = store.sqftState;
  return {
    menuOpened,
    activeFeature: sqftFromFeature ? sqftFromFeature.cartFeature : null
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavigationVanity);
